import React, { isValidElement } from 'react'
import PropTypes from 'prop-types'

import { Box, Paper, Typography } from '@material-ui/core'

import styles from './styles'
import theme from 'theme'

const SectionCard = ({
  title = '',
  subTitle,
  actions,
  children,
  titleContainerProps,
  isTable = false,
  hasPagination = false,
  id = 'section-card',
  roundedCard = false,
  ...rest
}) => {
  const useStyles = styles(isTable, hasPagination, roundedCard)
  const classes = useStyles()

  const isTitleElement = isValidElement(title)
  const isSubTitleElement = isValidElement(subTitle)

  return (
    <Box id={id}>
      <Paper
        className={classes.titleContainer}
        component={Box}
        px={3}
        py={2}
        {...titleContainerProps}
      >
        <Box>
          {!!title &&
            (isTitleElement ? (
              title
            ) : (
              <Typography variant="h6">{title}</Typography>
            ))}
          {!!subTitle &&
            (isSubTitleElement ? (
              subTitle
            ) : (
              <Typography variant="caption" color="secondary">
                {subTitle}
              </Typography>
            ))}
        </Box>
        {!!actions && (
          <Box display="flex" alignItems="center" gridGap={theme.spacing(2)}>
            {actions}
          </Box>
        )}
      </Paper>
      <Paper
        className={classes.childrenContainer}
        component={Box}
        p={isTable ? 0 : 3}
        {...rest}
      >
        {children}
      </Paper>
    </Box>
  )
}

SectionCard.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  hasPagination: PropTypes.bool,
  id: PropTypes.string,
  isTable: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  titleContainerProps: PropTypes.object,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  roundedCard: PropTypes.bool,
}

export default SectionCard
